import script from "./CustomButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomButton.vue?vue&type=script&setup=true&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=20413506&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20413506"]])

export default __exports__